import React, { useState, useEffect } from "react";
import { Card, CardImg, Button } from "reactstrap";
import { useNavigate } from "react-router-dom";


const ArticleCardCarousel = ({ articles, hideTrackButton = false }) => {

  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [hoveredArrow, setHoveredArrow] = useState(null);
  const [isHovered, setIsHovered] = useState(false);
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const handleTrackButtonClick = () => {
    if (!article) return;
    // Navigate to game dashboard with query param and state similar to other links in the app
    navigate(`/xr/app/${(article?.name || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')}?id=${article?.item_id}`, {
      state: { app_id: article?.item_id, data: article, fromTrackNow: true },
    });
  };

  const handleImageClick = () => {
    if (!article) return;
    // Only redirect without auto-tracking state
    navigate(`/xr/app/${(article?.name || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')}?id=${article?.item_id}`);
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? articles.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === articles.length - 1 ? 0 : prevIndex + 1
    );
  };
  if (!articles || articles.length === 0) {
    return <div>No articles available.</div>;
  }
  const article = articles[currentIndex];
  const getArrowButtonStyle = (type) => {
    // Mobile view (below 768px)
    if (windowWidth < 768) {
      return {
        width: "32px",
        height: "32px",
        borderRadius: "100px",
        background: hoveredArrow === type ? "#FFFFFF33" : "#0000001A",
        border: "1px solid #FFFFFF",
        padding: "6px",
        fontSize: "14px",
        color: "#FFFFFF",
        lineHeight: "1",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        transition: "background 0.3s ease",
      };
    }
    // Tablet view (768px - 992px)
    if (windowWidth < 992) {
      return {
        width: "36px",
        height: "36px",
        borderRadius: "100px",
        background: hoveredArrow === type ? "#FFFFFF33" : "#0000001A",
        border: "1px solid #FFFFFF",
        padding: "7px",
        fontSize: "16px",
        color: "#FFFFFF",
        lineHeight: "1",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        transition: "background 0.3s ease",
      };
    }
    // Desktop view (992px and above)
    return {
      width: "40px",
      height: "40px",
      borderRadius: "100px",
      background: hoveredArrow === type ? "#FFFFFF33" : "#0000001A",
      border: "1px solid #FFFFFF",
      padding: "8px",
      fontSize: "18px",
      color: "#FFFFFF",
      lineHeight: "1",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      transition: "background 0.3s ease",
    };
  };


  return (
    <Card className="h-100 position-relative overflow-hidden">
      {/* Navigation Arrows */}
      <div
        className="position-absolute top-0 end-0 d-flex gap-3 z-2 p-4"
        style={{ top: "24px", right: "24px" }}
      >
        <button
          onClick={handlePrev}
          onMouseEnter={() => setHoveredArrow("prev")}
          onMouseLeave={() => setHoveredArrow(null)}
          style={getArrowButtonStyle("prev")}
        >
          <svg 
            width={windowWidth < 768 ? "12" : windowWidth < 992 ? "14" : "16"} 
            height={windowWidth < 768 ? "11" : windowWidth < 992 ? "13" : "14"} 
            viewBox="0 0 18 16" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M16.5 8L1.5 8M1.5 8L8.25 14.75M1.5 8L8.25 1.25" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>

        </button>

        <button
          onClick={handleNext}
          onMouseEnter={() => setHoveredArrow("next")}
          onMouseLeave={() => setHoveredArrow(null)}
          style={getArrowButtonStyle("next")}
        >
          <svg 
            width={windowWidth < 768 ? "12" : windowWidth < 992 ? "14" : "16"} 
            height={windowWidth < 768 ? "11" : windowWidth < 992 ? "13" : "14"} 
            viewBox="0 0 18 16" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M1.5 8L16.5 8M16.5 8L9.75 1.25M16.5 8L9.75 14.75" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>

        </button>

      </div>

      {/* Image */}
      <CardImg
        src={article?.image_url || "https://via.placeholder.com/100"}
        alt="Article Image"
        style={{
          height: "100%",
          width: "100%",
          objectFit: "cover",
          objectPosition: "center",
          cursor: "pointer",
          display: "block",
        }}
        onClick={handleImageClick}
      />

      {/* Overlay Content */}
      <div
        className="position-absolute bottom-0 start-0 w-100 p-3 text-white"
        style={{
          background: "linear-gradient(to top, rgba(0,0,0,0.7), transparent)",
          zIndex: 1,
        }}
      >
        <div className="row align-items-center p-3 pb-0 pt-0 ps-0 mob_game_dashboard">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <button style={popularButtonStyle}>
              <span className="popu_btn">Popular</span> <span role="img" aria-label="star">⭐</span>
            </button>
          </div>

          <div className="col-12 col-md-9 p-3">
            <span style={nameStyle}>
              {article?.name}
            </span>
            {/* description intentionally hidden for carousel display */}
          </div>

          {!hideTrackButton && (
            <div className="col-12 col-md-3 d-flex justify-content-start justify-content-md-end">
              <Button
                style={isHovered ? { ...getResponsiveButtonStyle(windowWidth), ...hoverStyle } : getResponsiveButtonStyle(windowWidth)}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                onClick={handleTrackButtonClick}
              >
                Track Now
              </Button>
            </div>
          )}
        </div>
      </div>
    </Card>
  );
};

// ✅ Style objects (keep them reusable)




const popularButtonStyle = {
  minWidth: "113px",
  height: "35px",
  padding: "8px 16px",
  background: "#0000001A",
  border: "1px solid #FFFFFF",
  borderRadius: "100px",
  backdropFilter: "blur(16px)",
  color: "#FFFFFF",
  fontFamily: "Rubik, sans-serif",
  fontSize: "12px",
  fontWeight: "500",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "6px",
  whiteSpace: "nowrap",
  cursor: "pointer",
};

const nameStyle = {
  display: "inline-block",
  width: "100%",
  maxWidth: "266px",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  fontFamily: "Rubik",
  fontWeight: 700,
  fontSize: "20px",
  lineHeight: "100%",
  letterSpacing: "0%",
};

const descriptionStyle = {
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

// Responsive button style function
const getResponsiveButtonStyle = (windowWidth) => {
  // Mobile view (below 768px)
  if (windowWidth < 768) {
    return {
      minWidth: "50px",
      backgroundColor: "#F6255A",
      borderRadius: "8px",
      border: "none",
      color: "#fff",
      fontSize: "9px",
      fontWeight: "500",
      cursor: "pointer",
      whiteSpace: "nowrap",
      padding: "3px 6px",
      transition: "background-color 0.2s ease",
    };
  }
  // Tablet view (768px - 992px)
  if (windowWidth < 992) {
    return {
      minWidth: "55px",
      backgroundColor: "#F6255A",
      borderRadius: "9px",
      border: "none",
      color: "#fff",
      fontSize: "10px",
      fontWeight: "500",
      cursor: "pointer",
      whiteSpace: "nowrap",
      padding: "4px 7px",
      transition: "background-color 0.2s ease",
    };
  }
  // Desktop view (992px and above)
  return {
    minWidth: "60px",
    backgroundColor: "#F6255A",
    borderRadius: "10px",
    border: "none",
    color: "#fff",
    fontSize: "11px",
    fontWeight: "500",
    cursor: "pointer",
    whiteSpace: "nowrap",
    padding: "4px 8px",
    transition: "background-color 0.2s ease",
  };
};

const baseStyle = {
  minWidth: "90px",
  backgroundColor: "#F6255A",
  borderRadius: "10px",
  border: "none",
  color: "#fff",
  fontSize: "12px",
  fontWeight: "500",
  cursor: "pointer",
  whiteSpace: "nowrap",
  padding: "8px 12px",

  // Smooth transition when background changes
  transition: "background-color 0.2s ease",
};

const hoverStyle = {
  backgroundColor: "#FF6680", // a lighter pink
};

export default ArticleCardCarousel;
